"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FieldLayout_1 = require("../FieldLayout");
var SelectableTextInput_1 = require("../controls/SelectableTextInput");
var helpers_1 = require("../controls/NumberInput/helpers");
var public_1 = require("../common/public");
exports.preventInputNotNumberValue = function (newValue, minValue, maxValue) {
    if (newValue === '') {
        return false;
    }
    var _a = helpers_1.parseTextInputValue(newValue), value = _a.value, isInvalid = _a.isInvalid;
    if (isInvalid) {
        return true;
    }
    if ((value || 0) > maxValue || (value || 0) < minValue) {
        return true;
    }
    var numberValue = helpers_1.parseTextToNumber(value);
    return numberValue === undefined;
};
exports.SelectableNumberInputField = function (_a) {
    var label = _a.label, errorText = _a.errorText, error = _a.error, data = _a.data, minValue = _a.minValue, maxValue = _a.maxValue, value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement(FieldLayout_1.FieldLayout, { label: label, error: errorText },
        react_1.default.createElement(SelectableTextInput_1.SelectableTextInput, { preventInputValue: function (newValue) {
                return exports.preventInputNotNumberValue(newValue, minValue, maxValue);
            }, value: value === null ? '' : "" + value, data: data, onChange: function (value) {
                onChange(value === '' ? null : parseInt(value, 10));
            }, size: public_1.CONTROL_SIZE.xxs, error: error })));
};
//# sourceMappingURL=SelectableNumberInputField.js.map